/** A plan may finish after the voice screen closes. It must never be advanced. */
export async function settleAgentCreation<T>(data: {run:T;generation:number}, generation: number, accept: (run:T)=>void, cancel: (run:T)=>Promise<unknown>) {
 if(data.generation !== generation) { await cancel(data.run); return; }
 accept(data.run);
}
export async function cancelAgentRun<T extends {id:string;status:string}>(run:T, api:{cancel(run:T):Promise<T>;get(id:string):Promise<T>}): Promise<T> {
 if(['completed','cancelled','failed'].includes(run.status)) return run;
 try { return await api.cancel(run); }
 catch(error) {
  if(!error || typeof error !== 'object' || !('status' in error) || error.status !== 409) throw error;
  const latest=await api.get(run.id);
  return ['completed','cancelled','failed'].includes(latest.status) ? latest : api.cancel(latest);
 }
}
export const mayApplyAgentResponse=(runId:string, startedGeneration:number, currentGeneration:number,suspended:ReadonlySet<string>)=>startedGeneration===currentGeneration&&!suspended.has(runId);
